import { ApplicationType } from './../enum/ApplicationType.enum';
import { EncodingDataService } from './encoding-data.service';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { StoreLocaleService } from './store-locale.service';
import { HttpClient } from '@angular/common/http';
import { EndPointUrl } from '../enum/api.enum';
import { OperationTransaction } from '../enum/OperationTransaction.enum';
import { EnvService } from './env.service';
import { CurrentUser } from '../interfaces/current-user.interface';

export type AccessFeature = [
    'solde-data',
    'solde-sms',
    'identification',
    'activation'
];

@Injectable({
    providedIn: 'root',
})
export class MappingService {
    public currentUser: CurrentUser | null;
    public profil: any;
    public appReadStatut: boolean;
    public currentPermissions: any[];
    public listOperations: any[];
    public listOperationTraitementVue: any[];
    public structureGlobale: any;
    public logoTenant: any;
    public tenant: any;
    public grafanaLink: string;
    public rejetLink: string;
    public detectionApproUrl: string;
    public approLink: string;
    public typeNiveau: string;
    public baseUrl: string;
    public fileUrl: string;
    public minioUrl: string;
    public noderedUrl: string;
    public ws_server: string;
    public applicationType: string;
    public suffixEmail: string;
    public appName: string;
    public sourceStockTenantSim: string;
    public sourceStockOrangeSim: string;
    public sourceSoldeDotation: string;
    public sourceSoldeDotationOrange: string;
    public _volumeDataGlobalSource: BehaviorSubject<string> =
        new BehaviorSubject('');
    public volumeDataGlobal$ = this._volumeDataGlobalSource.asObservable();
    public _ligneCreditSource: BehaviorSubject<string> = new BehaviorSubject(
        ''
    );
    public ligneCreditGlobal$ = this._ligneCreditSource.asObservable();
    public dashbordTransactionSLa: string;
    public notifications: number;
    public currentVariables: any;
    public analyseAlarmeNormales: any;
    public analyseAlarmeMineures: any;
    public analyseAlarmeMajeures: any;
    public analyseAlarmeCritiques: any;
    public analyseAlarmeGenerees: any;
    public getAccessFeature: AccessFeature;
    constructor(
        private encodingService: EncodingDataService,
        private storeLocaleService: StoreLocaleService,
        private http: HttpClient,
        private envService: EnvService
    ) {
        this.currentVariables = this.encodingService.getData('dashboard_links');
        this.grafanaLink = this.currentVariables?.dashboardGrafana;
        this.approLink = this.currentVariables?.dashboardAppro;
        this.detectionApproUrl = this.currentVariables?.dashboardAppro;
        this.rejetLink = this.tenant?.lien_dashboard_rejets;
        this.analyseAlarmeNormales =
            this.currentVariables?.analyseAlarmeNormales;
        this.analyseAlarmeMineures =
            this.currentVariables?.analyseAlarmeMineures;
        this.analyseAlarmeMajeures =
            this.currentVariables?.analyseAlarmeMajeures;
        this.analyseAlarmeCritiques =
            this.currentVariables?.analyseAlarmeCritiques;
        this.analyseAlarmeGenerees =
            this.currentVariables?.analyseAlarmeGenerees;
        this.getAccessFeature = this.currentVariables?.modules;
        this.sourceStockTenantSim =
            this.envService.messageApp.sourceStockTenantSim;
        this.sourceStockOrangeSim =
            this.envService.messageApp.sourceStockOrangeSim;
        this.sourceSoldeDotation =
            this.envService.messageApp.sourceSoldeDotation;
        this.sourceSoldeDotationOrange =
            this.envService.messageApp.sourceSoldeDotationOrange;
        this.storeLocaleService.tenantData$.subscribe((res: any) => {
            this.currentUser = res ?? this.encodingService.getData('user_data');
            this.baseUrl = `${this.currentUser?.tenant?.url_backend}/api/v1/`;
            this.fileUrl = `${this.currentUser?.tenant?.url_minio}/`;
            this.minioUrl = `${this.currentUser?.tenant?.url_minio}/`;
            // this.noderedUrl = this.currentUser?.tenant?.url_nodered;
            // this.ws_server = this.currentUser?.tenant?.ws_server;
            this.tenant = this.currentUser?.tenant;
            this.structureGlobale =
                this.currentUser?.structure_organisationnelle;
            this.logoTenant = `${this.fileUrl}${this.tenant?.logo_tenant}`;
            // this.profil = this.currentUser?.profil;
            this.appReadStatut = this.profil?.mode_lecture;
            this.dashbordTransactionSLa = this.tenant?.url_demandes_sla;
            // const newDatatEnv = {
            //     ...this.currentUser?.env,
            //     typeNiveau: 'Type Emplacement',
            // };
            // this.typeNiveau = newDatatEnv?.typeNiveau;
            this.applicationType = this.tenant?.application;
            this.suffixEmail = this.tenant?.suffixe_email;
            // this.notifications = this.currentUser?.notifications;
            if (this.applicationType === ApplicationType.PATRIMOINESIM) {
                this.appName = this.envService.headerSettings.appTypePS;
                this.listOperations = Object.values(
                    OperationTransaction
                ).filter(
                    (item) =>
                        item !== OperationTransaction.ACHAT_SERVICE &&
                        item !== OperationTransaction.PROVISIONNING
                );
                Object.values(OperationTransaction).forEach((item) => {
                    this.listOperationTraitementVue.push(item);
                });
            } else if (this.applicationType === ApplicationType.MONITORING) {
                this.appName = this.envService.headerSettings.appTypeSM;
                this.listOperations = Object.values(
                    OperationTransaction
                ).filter(
                    (item) =>
                        item !== OperationTransaction.ACHAT_SERVICE &&
                        item !== OperationTransaction.PROVISIONNING &&
                        item !== OperationTransaction.SWAP &&
                        item !== OperationTransaction.VOLUME_DATA
                );
                this.listOperationTraitementVue = Object.values(
                    OperationTransaction
                ).filter(
                    (item) =>
                        item !== OperationTransaction.ACHAT_SERVICE &&
                        item !== OperationTransaction.PROVISIONNING &&
                        item !== OperationTransaction.SWAP &&
                        item !== OperationTransaction.VOLUME_DATA
                );
            }
            // if (this.currentUser !== null) {
            //   this.GetAllPortefeuilleSecond(this.baseUrl)
            // }
        });
        this.storeLocaleService._permissions$.subscribe((res: any) => {
            this.currentPermissions =
                res ?? this.encodingService.getData('current_menu');
        });
        if (encodingService.getData('user')) {
            // this.GetAllPortefeuille();
        }
        this.IsAction();
    }

    public GetAllPortefeuille() {
        const url: string = <string>EndPointUrl.GET_ALL_PORTEFEUILLE;
        this.http.get(`${this.baseUrl}${url}`).subscribe({
            next: (res) => {
                this._volumeDataGlobalSource.next(
                    res['data']?.filter((item: any) => {
                        return item.type === 'volume-data';
                    })[0].solde
                );
                this._ligneCreditSource.next(
                    res['data']?.filter((item: any) => {
                        return item.type === 'ligne-credit';
                    })[0].solde
                );
            },
            error: (err) => {},
        });
    }
    // public GetAllPortefeuilleSecond(uri: string) {
    //   const url: string = (<string>EndPointUrl.GET_ALL_PORTEFEUILLE);
    //   this.http.get(`${uri}${url}`)
    //     .subscribe({
    //       next: (res) => {
    //         this._volumeDataGlobalSource.next(res['data']?.filter((item: any) => { return item.type === 'volume-data' })[0].solde);
    //         this._ligneCreditSource.next(res['data']?.filter((item: any) => { return item.type === 'ligne-credit' })[0].solde);
    //       },
    //       error: (err) => {
    //       }
    //     });
    // }

    statutContrat(statut: string): any {
        switch (statut) {
            case 'actif': {
                return { 'badge-success': true };
            }
            case 'suspendu': {
                return { 'badge-danger': true };
            }
            default:
                return { 'badge-secondary': true };
        }
    }
    IsAction(): boolean {
        return !this.appReadStatut;
    }
}
